import {Card, DataStatus} from 'platform/components';
import {Box, Grid, GridItem, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {VehicleTypeEnumObject} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {FeatureSelector} from '@dms/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RentalVehicleFormType} from '../../types/RentalVehicleFormType';
import {CebiaWidget} from './components/CebiaWidget';
import {FeatureMarketAnalysis} from './components/FeatureMarketAnalysis';

interface FeaturesProps extends RequiredTestIdProps {
  formApi: UseFormReturn<RentalVehicleFormType>;
  isLoading: boolean;
}

export function Features(props: FeaturesProps) {
  const vehicleType = useWatch({control: props.formApi.control, name: 'type'});

  return (
    <Box padding={4}>
      <Grid columns={3}>
        <GridItem span={2}>
          <Card title={i18n.t('general.labels.allFeatures')} isExpandable>
            <DataStatus isLoading={props.isLoading}>
              <FeatureSelector
                formApi={props.formApi}
                name="features"
                vehicleType={vehicleType.at(0) as VehicleTypeEnumObject}
                columns={3}
                data-testid={suffixTestId('featureSelector', props)}
              />
            </DataStatus>
          </Card>
        </GridItem>
        <GridItem>
          <VStack spacing={4}>
            <CebiaWidget
              isLoading={props.isLoading}
              formApi={props.formApi}
              data-testid={suffixTestId('cebiaWidget', props)}
            />
            <FeatureMarketAnalysis
              isLoading={props.isLoading}
              formApi={props.formApi}
              data-testid={suffixTestId('featureMarketAnalysis', props)}
            />
          </VStack>
        </GridItem>
      </Grid>
    </Box>
  );
}
